export type ManualLocale = "en" | "de" | "fr";

export const MANUAL_LOCALES: { code: ManualLocale; label: string }[] = [
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
];

const COOKIE = "sepm_ui_lang";
const STORAGE = "i18nextLng";

export function normalizeManualLocale(value: string | null | undefined): ManualLocale | null {
  const code = (value || "").toLowerCase().split("-")[0].split("_")[0];
  if (code === "en" || code === "de" || code === "fr") return code;
  return null;
}

function readCookie(name: string) {
  try {
    const parts = `; ${document.cookie}`.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop()?.split(";").shift() || "");
    }
  } catch {
    /* ignore */
  }
  return "";
}

function writeSharedCookie(name: string, value: string) {
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    "path=/",
    `max-age=${365 * 24 * 60 * 60}`,
    "SameSite=Lax",
  ];
  if (window.location.protocol === "https:") parts.push("Secure");
  const host = window.location.hostname;
  if (host === "sepm.ch" || host.endsWith(".sepm.ch")) parts.push("domain=.sepm.ch");
  document.cookie = parts.join("; ");
}

/** Query, shared cookie, then local storage. Null when the visitor has not chosen a language. */
export function readStoredManualLocale(): ManualLocale | null {
  try {
    const query = new URLSearchParams(window.location.search).get("lang");
    return (
      normalizeManualLocale(query) ||
      normalizeManualLocale(readCookie(COOKIE)) ||
      normalizeManualLocale(localStorage.getItem(STORAGE))
    );
  } catch {
    return null;
  }
}

export function readManualLocale(): ManualLocale {
  return readStoredManualLocale() || "en";
}

export function persistManualLocale(locale: ManualLocale) {
  try {
    localStorage.setItem(STORAGE, locale);
  } catch {
    /* ignore */
  }
  writeSharedCookie(COOKIE, locale);
}
